import { render } from "./encerrarAtendimento.vue?vue&type=template&id=c3d51924&scoped=true"
import script from "./encerrarAtendimento.vue?vue&type=script&lang=js"
export * from "./encerrarAtendimento.vue?vue&type=script&lang=js"

import "./encerrarAtendimento.vue?vue&type=style&index=0&id=c3d51924&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3d51924"]])

export default __exports__